import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound, ShieldAlert } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export function ForcePasswordChange() {
  const { user, refreshUser, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  if (!user || !user.must_change_password) return null;

  const save = async () => {
    if (next.length < 6) return toast.error("La nuova password deve avere almeno 6 caratteri");
    if (next !== confirm) return toast.error("Le due password non coincidono");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata. Benvenuto!");
      await refreshUser();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-background/90 backdrop-blur-sm grid place-items-center p-4" data-testid="force-password-overlay">
      <Card className="w-full max-w-sm p-6">
        <div className="flex items-center gap-2 text-amber-500 text-xs uppercase tracking-[0.2em] mb-2">
          <ShieldAlert className="h-4 w-4" /> Primo Accesso
        </div>
        <h2 className="font-heading text-xl font-bold tracking-tight flex items-center gap-2">
          <KeyRound className="h-5 w-5 text-primary" /> Imposta la tua password
        </h2>
        <p className="text-sm text-muted-foreground mt-1">Per motivi di sicurezza devi scegliere una nuova password prima di continuare.</p>
        <div className="space-y-4 mt-6">
          <div className="space-y-2">
            <Label htmlFor="fc">Password attuale (quella ricevuta)</Label>
            <Input id="fc" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="force-current-input" autoComplete="current-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="fn">Nuova password</Label>
            <Input id="fn" type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="force-new-input" autoComplete="new-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="fcn">Conferma nuova password</Label>
            <Input id="fcn" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="force-confirm-input" autoComplete="new-password" />
          </div>
          <Button className="w-full" onClick={save} disabled={saving} data-testid="force-save-btn">
            {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null} Aggiorna e Continua
          </Button>
          <button className="w-full text-xs text-muted-foreground hover:text-foreground" onClick={logout} data-testid="force-logout-btn">
            Esci
          </button>
        </div>
      </Card>
    </div>
  );
}
